import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, DialogTitle, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const PREFIX = 'ClientWizardHeader';

const classes = {
  header: `${PREFIX}-header`,
  htop: `${PREFIX}-htop`,
  hbottom: `${PREFIX}-hbottom`,
  title: `${PREFIX}-title`,
  closeButton: `${PREFIX}-closeButton`,
  clientNameTitle: `${PREFIX}-clientNameTitle`,
};

const Root = styled(DialogTitle)(({ theme }) => ({
  [`&.${classes.header}`]: {
    backgroundColor: theme.palette.lightActionDisabled04p.main,
    padding: theme.spacing(6, 18, 3, 18),
    position: 'relative',
  },

  [`& .${classes.htop}`]: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },

  [`& .${classes.hbottom}`]: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 16,
    marginTop: -12,
    fontFamily: 'Bitter',
  },

  [`& .${classes.title}`]: {
    fontFamily: 'Bitter',
    color: theme.palette.lightTextPrimary.main,
    fontSize: 36,
    fontWeight: 700,
    lineHeight: '48px',
    letterSpacing: '0.5px',
    margin: 'auto 0',
  },

  [`& .${classes.clientNameTitle}`]: {
    color: theme.palette.lightActionDisabled90p.main,
    fontFamily: 'Source Sans Pro',
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '157%',
    letterSpacing: '1.5px',
    textTransform: 'uppercase',
  },

  [`& .${classes.closeButton}`]: {
    position: 'absolute',
    right: theme.spacing(0.375),
    top: theme.spacing(0.375),
  },
}));

interface FullScreenDialogHeaderProps {
  clientName: string;
  title: string;
  close: (saved: boolean) => void;
}

export default function FullScreenDialogHeader({
  clientName,
  title,
  close,
}: FullScreenDialogHeaderProps) {
  const handleClose = () => {
    if (close) {
      close(false);
    }
  };

  return (
    <Root className={classes.header}>
      <Box className={classes.htop}>
        <Typography variant="h6" className={classes.clientNameTitle}>
          {clientName}
        </Typography>
        <IconButton
          onClick={handleClose}
          className={classes.closeButton}
          aria-label="close"
          data-testid="close"
          size="large">
          <CloseIcon sx={{ fontSize: 35 }} />
        </IconButton>
      </Box>
      <Box className={classes.hbottom}>
        <Typography variant="h4" className={classes.title}>
          {title}
        </Typography>
      </Box>
    </Root>
  );
}
